import React, { useState, useRef, useEffect } from 'react';

interface StableTooltipProps {
  content: string;
  children: React.ReactNode;
  side?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
}

export function StableTooltip({ 
  content, 
  children, 
  side = 'top',
  className = '' 
}: StableTooltipProps) {
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const triggerRef = useRef<HTMLDivElement>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);

  const showTooltip = () => {
    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const scrollX = window.pageXOffset;
      const scrollY = window.pageYOffset;
      
      let x = rect.left + scrollX + rect.width / 2;
      let y = rect.top + scrollY;
      
      if (side === 'top') {
        y = rect.top + scrollY - 10;
      } else if (side === 'bottom') {
        y = rect.bottom + scrollY + 10;
      }
      
      setPosition({ x, y });
      setIsVisible(true);
    }
  };

  const hideTooltip = () => {
    setIsVisible(false);
  };

  return (
    <>
      <div
        ref={triggerRef}
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
        className={className}
      >
        {children}
      </div>
      
      {isVisible && (
        <div
          ref={tooltipRef}
          className="fixed z-50 px-3 py-1.5 text-sm bg-gray-900 text-white rounded-md shadow-lg pointer-events-none"
          style={{
            left: position.x,
            top: position.y,
            transform: side === 'top' ? 'translate(-50%, -100%)' : 'translate(-50%, 0)',
            maxWidth: '320px',
            wordWrap: 'break-word'
          }}
        >
          {content}
          <div
            className={`absolute w-2 h-2 bg-gray-900 transform rotate-45 ${
              side === 'top' 
                ? 'bottom-[-4px] left-1/2 translate-x-[-50%]'
                : 'top-[-4px] left-1/2 translate-x-[-50%]'
            }`}
          />
        </div>
      )}
    </>
  );
}